export interface SendSMSLinkApi {
  email: string;
  phoneNumber: string;
  dossierNumber?: string;
}

export interface GetSuperAdminSMSStatsAPI {
  start: string;
  end: string;
}

export interface SuperAdminSMSStatsAPIResponse {
  sms: {
    dossierId: string;
    fitterId: string;
    phone: string;
    timestamp: string;
    smsType: string;
    nbCharacters: number;
  }[];
}
